import { render, staticRenderFns } from "./stock_detail_list.vue?vue&type=template&id=2c43d744&scoped=true"
import script from "./stock_detail_list.vue?vue&type=script&lang=js"
export * from "./stock_detail_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43d744",
  null
  
)

export default component.exports